export default "__VITE_ASSET__BSx3FiZ8__"